import { render, staticRenderFns } from "./productAnalysis.vue?vue&type=template&id=b36c4ab2&scoped=true"
import script from "./productAnalysis.vue?vue&type=script&lang=js"
export * from "./productAnalysis.vue?vue&type=script&lang=js"
import style0 from "./productAnalysis.vue?vue&type=style&index=0&id=b36c4ab2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36c4ab2",
  null
  
)

export default component.exports